import React from 'react';
import { Card, Row, Col, Placeholder } from 'react-bootstrap';

// Skeleton para tarjetas de estadísticas
export const StatCardSkeleton = () => (
  <Card className="border-0 shadow-sm h-100">
    <Card.Body>
      <div className="d-flex align-items-center">
        <div className="me-3">
          <Placeholder as="div" animation="glow">
            <Placeholder 
              style={{ 
                width: '48px', 
                height: '48px', 
                borderRadius: '50%' 
              }} 
            />
          </Placeholder>
        </div>
        <div className="flex-grow-1">
          <Placeholder as="div" animation="glow">
            <Placeholder xs={8} className="mb-2" />
            <Placeholder xs={6} size="sm" />
          </Placeholder>
        </div>
      </div>
    </Card.Body>
  </Card>
);

// Skeleton para tabla de datos
export const TableSkeleton = ({ rows = 5, columns = 6 }) => (
  <div className="table-responsive">
    <table className="table table-hover">
      <thead>
        <tr>
          {Array.from({ length: columns }).map((_, index) => (
            <th key={index}>
              <Placeholder as="div" animation="glow">
                <Placeholder xs={8} />
              </Placeholder>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <td key={colIndex}>
                <Placeholder as="div" animation="glow">
                  <Placeholder 
                    xs={colIndex === 0 ? 12 : Math.floor(Math.random() * 8) + 4} 
                    size={colIndex === 0 ? "lg" : "sm"}
                  />
                </Placeholder>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

// Skeleton para dashboard completo
export const DashboardSkeleton = () => (
  <div className="infomedia-dashboard">
    {/* Header Skeleton */}
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <Placeholder as="h2" animation="glow">
          <Placeholder xs={6} />
        </Placeholder>
        <Placeholder as="p" animation="glow">
          <Placeholder xs={4} size="sm" />
        </Placeholder>
      </div>
      <div className="d-flex gap-2">
        <Placeholder.Button variant="outline-primary" xs={4} />
        <Placeholder.Button variant="primary" xs={4} />
      </div>
    </div>

    {/* Estadísticas Skeleton */}
    <Row className="mb-4">
      <Col lg={3} md={6} className="mb-3">
        <StatCardSkeleton />
      </Col>
      <Col lg={3} md={6} className="mb-3">
        <StatCardSkeleton />
      </Col>
      <Col lg={3} md={6} className="mb-3">
        <StatCardSkeleton />
      </Col>
      <Col lg={3} md={6} className="mb-3">
        <StatCardSkeleton />
      </Col>
    </Row>

    {/* Tabla Skeleton */}
    <Card className="mb-4">
      <Card.Header>
        <Placeholder as="h5" animation="glow">
          <Placeholder xs={4} />
        </Placeholder>
      </Card.Header>
      <Card.Body>
        <TableSkeleton rows={8} columns={6} />
      </Card.Body>
    </Card>
  </div>
);

// Skeleton para interfaz de mapeo
export const MappingSkeleton = () => (
  <div className="infomedia-mapping">
    {/* Progress Cards Skeleton */}
    <Row className="mb-4">
      <Col lg={4} md={6} className="mb-3">
        <StatCardSkeleton />
      </Col>
      <Col lg={4} md={6} className="mb-3">
        <StatCardSkeleton />
      </Col>
      <Col lg={4} md={6} className="mb-3">
        <StatCardSkeleton />
      </Col>
    </Row>

    {/* Filtros Skeleton */}
    <Row className="mb-3">
      <Col md={4}>
        <Placeholder as="div" animation="glow">
          <Placeholder xs={12} style={{ height: '38px' }} />
        </Placeholder>
      </Col>
      <Col md={2}>
        <Placeholder as="div" animation="glow">
          <Placeholder xs={12} style={{ height: '38px' }} />
        </Placeholder>
      </Col>
      <Col md={2}>
        <Placeholder as="div" animation="glow">
          <Placeholder xs={12} style={{ height: '38px' }} />
        </Placeholder>
      </Col>
      <Col md={4} className="text-end">
        <Placeholder.Button variant="primary" xs={8} />
      </Col>
    </Row>

    {/* Tabla principal Skeleton */}
    <Card className="border-0 shadow-sm">
      <Card.Header className="bg-light">
        <Placeholder as="h6" animation="glow">
          <Placeholder xs={6} />
        </Placeholder>
      </Card.Header>
      <Card.Body className="p-0">
        <TableSkeleton rows={10} columns={7} />
      </Card.Body>
    </Card>
  </div>
);

// Skeleton para filas individuales (útil para carga incremental)
export const TableRowSkeleton = ({ columns = 6 }) => (
  <tr>
    {Array.from({ length: columns }).map((_, index) => (
      <td key={index}>
        <Placeholder as="div" animation="glow">
          <Placeholder xs={Math.floor(Math.random() * 8) + 4} size="sm" />
        </Placeholder>
      </td>
    ))}
  </tr>
);

// Skeleton para indicador de carga más datos
export const LoadMoreSkeleton = () => (
  <div className="text-center py-3">
    <Placeholder as="div" animation="glow">
      <Placeholder.Button variant="outline-primary" xs={6} />
    </Placeholder>
    <div className="mt-2">
      <Placeholder as="div" animation="glow">
        <Placeholder xs={8} size="sm" />
      </Placeholder>
    </div>
  </div>
);

const SkeletonComponents = {
  StatCardSkeleton,
  TableSkeleton,
  DashboardSkeleton,
  MappingSkeleton,
  TableRowSkeleton,
  LoadMoreSkeleton
};

export default SkeletonComponents;